import { render } from "./FullReportTableUsersStatus.vue?vue&type=template&id=470c1927"
import script from "./FullReportTableUsersStatus.vue?vue&type=script&lang=js"
export * from "./FullReportTableUsersStatus.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__